mutation DeleteIntegrationCredentials(
  $workspaceId: ID!
  $integrationId: ID!
) {
  success: deleteIntegrationCredentials(
    workspaceId: $workspaceId
    integrationId: $integrationId
  )
}
